import { all } from 'redux-saga/effects';
import tenantSaga from '@Sagas/tenantSaga';
import sellerSaga from '@Sagas/sellerSaga';
import userSaga from '@Sagas/userSaga';
import productSaga from '@Sagas/productSaga';
import grnSaga from '@Sagas/grnSaga';
import addressSaga from '@Sagas/addressSaga';
import workflowSaga from './workflowSaga';
import payoutSaga from './payoutSaga';
import offerSaga from './offerSaga';
import cartSaga from './cartSaga';
import paymentSaga from './paymentOutgoingSaga';
// Purchase
import purchaseOrderSaga from './purchaseOrderSaga';
import bulkPOSaga from './purchase/purchaseOrders/bulkPOSaga';
import expenseSaga from './purchase/expense/expenseSaga';
import rfqSaga from './purchase/rfq/rfqSaga';

import paymentRequestSaga from './paymentRequestSaga';
import reportSaga from './reportSaga';
// reportV2Saga
import reportV2Saga from './ReportsV2/reportV2Saga';

import uomSaga from './uomSaga';
import taxSaga from './taxSaga';
import customerSaga from './customerSaga';
import invoiceSaga from './invoiceSaga';
import cnSaga from './cnSaga';
import analyticsSaga from './application/analyticsSaga';
import forecastSaga from './application/forecastSaga';
import memberSaga from './memberSaga';

// Production
import resourceSaga from './production/resourceSaga';
import processSaga from './production/processSaga';
import templateRouteSaga from './production/templateRouteSaga';
import jobWorkSaga from './production/jobWorkSaga';
import mrpV2Saga from './production/mrpV2Saga';
import manualProductionEntrySaga from './production/manualProductionEntrySaga';

// Quality
import qcPointSaga from './quality/qcPointSaga';
import qualityCheckSaga from './quality/qualityCheckSaga';

// gate document

import gateDocumentSaga from './logistics/gateDocument/gateDocumentSaga';

// Sales
import soSaga from './sales/soSaga';

// notification centre
import notificationCentreSaga from './configurations/notificationCentreSaga';

import dnSaga from './dnSaga';
import purchaseRequestSaga from './purchaseRequestSaga';
import departmentSaga from './departmentSaga';
import stSaga from './stSaga';
import dcSaga from './dcSaga';
import moSaga from './moSaga';
import bomSaga from './bomSaga';
import categorySaga from './categorySaga';
import attachmentSaga from './attachmentSaga';
import trackerSaga from './trackerSaga';
import batchSaga from './batchSaga';
import activityLogSaga from './activityLogSaga';
import tagSaga from './tagSaga';

// Integrations
import IntegrationSaga from './integrations/integrationSaga';
import tallyIntegrationSaga from './integrations/tallyIntegrationSaga';
import einvoiceEwaybillSaga from './integrations/einvoiceEwaybillSaga';
import zohoIntegrationSaga from './integrations/zohoIntegrationSaga';
import unicommerceIntegrationSaga from './integrations/unicommerceIntegrationSaga';
import shopifyIntegrationSaga from './integrations/shopifyIntegrationSaga';
import whatsappIntegrationSaga from './integrations/whatsappIntegrationSaga';

// Busy Integration
import busyIntegrationSaga from './integrations/busyIntegrationSaga';

// Configurations
import paymentTermSaga from './configurations/paymentTermSaga';
import customStatusSaga from './configurations/customStatusSaga';
import generalConfigurationSaga from './configurations/generalConfigurationSaga';
import docConfigSaga from './docConfigSaga';
import tdsTcsSaga from './configurations/tdsTcsSaga';
import cfV2Saga from './configurations/cfV2Saga';
import labelGenerationSaga from './configurations/labelGenerationSaga';

// Setting
import inventoryLocationSaga from './settings/inventoryLocationSaga';
import cmSaga from './settings/cmSaga';
import maskingPolicySaga from './settings/maskingPolicySaga';

// Inventory
import ProductBundleSaga from './inventory/productBundleSaga';
import StockMasterSaga from './inventory/stockMasterSaga';
import PriceList from './inventory/priceListSaga';
import dailyRunRateSaga from './inventory/dailyRunRateSaga';

// VendorRating
import VendorRatingSaga from './configurations/vendorRatingSaga';

// Currencies
import CurrenciesSaga from './configurations/currenciesSaga';

// ExtraCharges
import ExtraChargesSaga from './configurations/extraChargesSaga';


// Payment Modes
import PaymentModeSaga from './configurations/paymentModeSaga';

// Reservation
import ReservationSaga from './reservationSaga';

// Quick Update
import quickUpdateSaga from './quickUpdate/quickUpdateSaga';

// OCR
import OCRSaga from './ocrSaga';

// add to cart
import addToCartSaga from './addToCart/addToCartSaga'
import productV2Saga from './inventory/productV2Saga';
import { Sagas } from '../modules';

/**
 *
 */
export default function* rootSaga() {
  yield all([
    userSaga(),
    productSaga(),
    tenantSaga(),
    grnSaga(),
    sellerSaga(),
    addressSaga(),
    workflowSaga(),
    payoutSaga(),
    offerSaga(),
    cartSaga(),
    paymentSaga(),
    productV2Saga(),

    // Purchase
    purchaseOrderSaga(),
    bulkPOSaga(),
    expenseSaga(),
    rfqSaga(),

    paymentRequestSaga(),
    reportSaga(),
    // reportV2Saga
    reportV2Saga(),

    uomSaga(),
    taxSaga(),
    customerSaga(),
    invoiceSaga(),
    cnSaga(),
    soSaga(),
    dnSaga(),
    purchaseRequestSaga(),
    departmentSaga(),
    stSaga(),
    dcSaga(),
    moSaga(),
    bomSaga(),
    categorySaga(),
    attachmentSaga(),
    trackerSaga(),
    batchSaga(),
    tagSaga(),

    // Production
    resourceSaga(),
    processSaga(),
    templateRouteSaga(),
    jobWorkSaga(),
    mrpV2Saga(),
    manualProductionEntrySaga(),

    // Quality
    qcPointSaga(),
    qualityCheckSaga(),

    // gate document
    gateDocumentSaga(),

    // Integrations
    IntegrationSaga(),
    tallyIntegrationSaga(),
    zohoIntegrationSaga(),
    unicommerceIntegrationSaga(),
    shopifyIntegrationSaga(),
    whatsappIntegrationSaga(),
    einvoiceEwaybillSaga(),
    busyIntegrationSaga(),
    // Configurations
    paymentTermSaga(),
    activityLogSaga(),
    customStatusSaga(),
    generalConfigurationSaga(),
    docConfigSaga(),
    tdsTcsSaga(),
    cfV2Saga(),
    labelGenerationSaga(),

    // Settings
    inventoryLocationSaga(),
    cmSaga(),
    maskingPolicySaga(),

    // Inventory
    ProductBundleSaga(),
    StockMasterSaga(),
    PriceList(),
    dailyRunRateSaga(),

    // Application
    analyticsSaga(),
    forecastSaga(),
    memberSaga(),

    // Vendor Rating
    VendorRatingSaga(),

    // Currencies
    CurrenciesSaga(),

    // Extra Charges
    ExtraChargesSaga(),

    // Payment Modes
    PaymentModeSaga(),

    // Reservation
    ReservationSaga(),

    // Quick Update
    quickUpdateSaga(),

    // Notification Centre
    notificationCentreSaga(),

    // OCR
    OCRSaga(),

    // add to cart
    addToCartSaga(),

    // Common sagas
    Sagas(),
  ]);
}
